export default "__VITE_ASSET__CXEKWknM__"